(() => {
  const init = (root) => {
    if (root.dataset.fitReady) return;
    root.dataset.fitReady = 'true';
    const $ = (selector) => root.querySelector(selector);
    const section = root.closest('[data-product-section]');
    const labels = JSON.parse($('[data-fit-strings]').textContent);
    const rows = Array.from(root.querySelectorAll('[data-fit-size]'));
    const range = $('[data-fit-range]');
    const breeds = Array.from(root.querySelectorAll('[data-fit-breed]'));
    let unit = 'cm';
    let recommendation;
    const aliases = { XS: ['xs', 'extra small', 'x-small'], S: ['s', 'small'], M: ['m', 'medium'], L: ['l', 'large'], XL: ['xl', 'extra large', 'x-large'] };
    const optionName = `Option-${root.dataset.sectionId}-${root.dataset.optionIndex}`;
    const optionInputs = () => Array.from(section?.querySelectorAll('input[type="radio"]') || []).filter(input => input.name === optionName);
    const matchingInput = size => optionInputs().find(input => aliases[size]?.includes(input.value.trim().toLowerCase()));
    const variants = JSON.parse(section?.querySelector('[data-variants-json]')?.textContent || '[]');
    const available = (input) => {
      if (!input) return false;
      const selected = Array.from(section.querySelectorAll('[data-variant-picker] fieldset')).map(field => Array.from(field.querySelectorAll('input')).find(input => input.checked)?.value);
      selected[Number(root.dataset.optionIndex)] = input.value;
      return variants.some(variant => variant.available && variant.options.every((value, index) => (selected[index] === undefined || value === selected[index])));
    };
    const format = cm => `${Math.round((unit === 'cm' ? cm : cm / 2.54) * 10) / 10}`;
    const update = () => {
      const breed = breeds[Number(range.value)];
      const chest = (Number(breed.dataset.chestMin) + Number(breed.dataset.chestMax)) / 2;
      const matches = rows.filter(row => chest >= Number(row.dataset.chestMin) && chest <= Number(row.dataset.chestMax));
      const clearance = row => Math.min(chest - Number(row.dataset.chestMin), Number(row.dataset.chestMax) - chest) / (Number(row.dataset.chestMax) - Number(row.dataset.chestMin));
      recommendation = matches.slice().sort((a,b) => clearance(b) - clearance(a) || rows.indexOf(b) - rows.indexOf(a))[0];
      breeds.forEach(el => { el.classList.toggle('is-active', el === breed); el.setAttribute('aria-hidden', String(el !== breed)); if (el !== breed) el.classList.remove('is-hopping'); });
      $('[data-fit-breed-name]').textContent = breed.dataset.breedName;
      $('[data-fit-average]').textContent = format(chest);
      $('[data-fit-breed-range]').textContent = `${format(Number(breed.dataset.chestMin))}–${format(Number(breed.dataset.chestMax))} ${unit}`;
      range.style.setProperty('--position', `${Number(range.value) / Number(range.max) * 100}%`);
      range.setAttribute('aria-valuetext', `${breed.dataset.breedName}, ${format(chest)} ${unit} approximate average chest${recommendation ? `, ${recommendation.dataset.fitSize} starting size` : ''}`);
      rows.forEach(row => { row.classList.toggle('is-match', matches.includes(row)); row.classList.toggle('is-suggested', row === recommendation); });
      const button = $('[data-fit-select]');
      $('[data-fit-result]').dataset.state = recommendation ? 'match' : 'check';
      $('[data-fit-result-size]').textContent = recommendation?.dataset.fitSize || labels.noMatch;
      $('[data-fit-result-label]').textContent = labels.result;
      $('[data-fit-actual-ranges]').textContent = recommendation ? `${labels.neck}: ${format(Number(recommendation.dataset.neckMin))}–${format(Number(recommendation.dataset.neckMax))} ${unit} · ${labels.chest}: ${format(Number(recommendation.dataset.chestMin))}–${format(Number(recommendation.dataset.chestMax))} ${unit}` : '';
      let text = recommendation ? (matches.length > 1 ? labels.overlap : labels.match) : labels.noMatchText;
      const input = recommendation && matchingInput(recommendation.dataset.fitSize);
      button.disabled = !recommendation || !available(input);
      if (recommendation && !input) text += ` ${labels.notOffered}`;
      else if (recommendation && !available(input)) text += ` ${labels.unavailable}`;
      $('[data-fit-result-text]').textContent = text;
      button.textContent = recommendation ? labels.choose.replace('[size]', recommendation.dataset.fitSize) : labels.noMatch;
    };
    range.addEventListener('input', update);
    root.querySelectorAll('[data-fit-unit]').forEach(radio => radio.addEventListener('change', () => {
      unit = radio.value;
      root.querySelectorAll('[data-fit-unit-label]').forEach(el => { el.textContent = unit; });
      update();
    }));
    $('[data-fit-stage]').addEventListener('click', () => {
      const dog = breeds[Number(range.value)];
      dog.classList.remove('is-hopping');
      void dog.offsetWidth;
      dog.classList.add('is-hopping');
    });
    $('[data-fit-select]').addEventListener('click', () => {
      if (!recommendation) return;
      const input = matchingInput(recommendation.dataset.fitSize);
      if (!available(input)) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      root.closest('dialog')?.close();
      input.focus();
    });
    section?.addEventListener('change', event => { if (event.target.closest('[data-variant-picker]')) update(); });
    update();
    // Funnel pages (e.g. the fit quiz) link here with ?fit=M to preselect the recommended size.
    const requested = new URLSearchParams(window.location.search).get('fit')?.trim().toUpperCase();
    const requestedInput = requested && rows.some(row => row.dataset.fitSize === requested) && matchingInput(requested);
    if (requestedInput && available(requestedInput)) {
      requestedInput.checked = true;
      requestedInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };
  const scan = scope => scope.querySelectorAll('[data-fit-finder]').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
